import { Box, Switch, Typography } from "@mui/material";
import { COLORS } from "assets";

export interface FormRowSwitchProps {
  label: string;
  description?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Bordered control row for denser forms where the toggle needs clearer affordance. */
  outlined?: boolean;
}

export default function FormRowSwitch({ label, description, checked, onChange, outlined }: FormRowSwitchProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        py: description || outlined ? 1.25 : 0.5,
        ...(outlined
          ? {
              px: 2,
              border: `1px solid ${COLORS.surface.border}`,
              borderRadius: `${COLORS.radius.md}px`,
              bgcolor: COLORS.surface.tableHeader
            }
          : null)
      }}
    >
      <Box flex={1} minWidth={0}>
        <Typography sx={{ color: COLORS.surface.primaryText, fontWeight: 500, fontSize: 15 }}>{label}</Typography>
        {description ? (
          <Typography variant="body2" sx={{ color: COLORS.surface.secondaryText, mt: 0.25 }}>
            {description}
          </Typography>
        ) : null}
      </Box>
      <Switch
        checked={checked}
        onChange={(_, next) => onChange(next)}
        sx={{
          flexShrink: 0,
          "& .MuiSwitch-switchBase.Mui-checked": {
            color: COLORS.primary,
            "& + .MuiSwitch-track": {
              bgcolor: COLORS.primary,
              opacity: 0.5
            }
          }
        }}
      />
    </Box>
  );
}
